import { useUser } from "auth";
import axios from "axios";
import { Box } from "components/Box";
import Button from "components/Button";
import { Panel } from "components/Panel";
import { Text } from "components/Text";
import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import mailSrc from "../../img/mailicon.svg";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.grey0};
  padding: 12px;
`;

const Logo = styled.img`
  margin-bottom: 36px;
  margin-top: 36px;
  width: 120px;
  max-width: 100%;
`;

const MailIcon = styled.img`
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 32px;
`;

export const RequireConfirmation = () => {
  const theme = useTheme();
  const { logout } = useUser();
  const [counter, setCounter] = useState<number>(0);

  useEffect(() => {
    const i = setInterval(() => {
      setCounter((old) => Math.max(0, old - 1));
    }, 1000);

    return () => {
      clearInterval(i);
    };
  }, []);

  const resend = () => {
    axios.put("/api/auth/resend-confirmation");
    setCounter(60);
  };

  return (
    <Container>
      <Logo src={theme.logo} />
      <Panel p={[3, 6]} width={600} mb={[0, "100px"]}>
        <MailIcon src={mailSrc} />
        <Text
          as="h1"
          fontSize={6}
          textAlign="center"
          mb={3}
          fontWeight={600}
          lineHeight={1.25}
        >
          Please Confirm Your
          <br /> Email Address.
        </Text>
        <Text mb={3} fontSize={4}>
          We sent you an email just so we can confirm it's really you! Check
          your inbox and click the link provided to activate your Aika account.
        </Text>
        <Text mb={5} fontSize={3}>
          If it's been a while or you didn't receive the email for some reason
          you can click the button below to resend it.
        </Text>
        <Box style={{ textAlign: "center" }} mb={5}>
          <Button ml="auto" mr="auto" disabled={counter > 0} onClick={resend}>
            Resend Verification Email {counter > 0 ? `(Wait ${counter}s)` : ""}
          </Button>
        </Box>
        <Text mb={3}>
          If you used a fake email address (we understand) and want to retain
          your existing data, drop us{" "}
          <a href="mailto:steve@aikahq.com">an email</a> to let us know and
          we'll change your email address for you to one that you control.
        </Text>
        <Box border={1} borderRadius={1} p={2} mb={5}>
          <Text fontWeight={600}>Why do I have to do this?</Text>
          <Text>
            We are required to confirm our users' email addresses to comply with
            various SPAM legislation around the world.
          </Text>
        </Box>
        <Box style={{ textAlign: "center" }}>
          <Button ml="auto" mr="auto" onClick={logout}>
            Logout
          </Button>
        </Box>
      </Panel>
    </Container>
  );
};
